// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"736":"96c77de8","977":"0e63b3f2"}[chunkId] + ".chunk.js";
};